// Example medication list (RxNorm or custom)
// For demo purposes, a small subset of common medications
const medicationList = [
  { code: "1049630", description: "Atorvastatin 20 MG Oral Tablet" },
  { code: "197361", description: "Lisinopril 10 MG Oral Tablet" },
  { code: "617314", description: "Metformin 500 MG Oral Tablet" },
  { code: "617320", description: "Metformin 1000 MG Oral Tablet" },
  { code: "617311", description: "Metoprolol Tartrate 50 MG Oral Tablet" },
  { code: "617314", description: "Simvastatin 20 MG Oral Tablet" },
  { code: "617315", description: "Amlodipine 5 MG Oral Tablet" },
  { code: "617316", description: "Amlodipine 10 MG Oral Tablet" },
  { code: "617317", description: "Hydrochlorothiazide 25 MG Oral Tablet" },
  { code: "617318", description: "Levothyroxine Sodium 50 MCG Oral Tablet" }
];

export function searchMedications(query) {
  if (!query || query.length < 2) return [];
  
  const searchTerm = query.trim().toLowerCase();
  return medicationList.filter(item =>
    item.code.toLowerCase().includes(searchTerm) ||
    item.description.toLowerCase().includes(searchTerm)
  );
}

export default medicationList;
